import { useSplunkTheme } from '@splunk/themes';
import { headerPaddingInterpolationTree } from './themeInterpolation';

export const useGetFlyoutHeaderPadding = () => {
    // when no context provider is used the default theme is Prisma/Dark/compact
    const { density, family } = useSplunkTheme();
    return headerPaddingInterpolationTree[family][density];
};
